.help {
  display: inline-flex;
}

/* Joni, Q6: hidden below 600px */
@media (max-width: 599.95px) {
  .help {
    display: none;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-2);
  max-width: 20rem;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: 600;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin: 0;
}

.row {
  display: flex;
  align-items: baseline;
  gap: var(--tuna-spacing-2);
}

.row dt {
  min-width: 3.5rem;
}

.key {
  padding: 0 var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  font-family: inherit;
  font-size: var(--tuna-typography-body2-fontSize);
}

.description {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
}

.footnote {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}
